import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ITagsWebServiceClient } from "@common/resources/resources";

@Injectable()
export class CorrespondantTagAccessResolver implements Resolve<any> {

  constructor(private tagsWebServiceClient: ITagsWebServiceClient) {
  }

  resolve() {
    return this.tagsWebServiceClient.isFormulaireDematEnabled();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/correspondant-tag-access.resolver.ts